import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';

// ==========================================
// 1. IMPORTACIONES PÚBLICAS (Web Principal)
// ==========================================
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import GranMaestro from './pages/autoridades/GranMaestro';
import GranCuadro from './pages/autoridades/GranCuadro';
import Historia from './pages/nosotros/Historia';
import AntiguosLinderos from './pages/nosotros/AntiguosLinderos';
import Gobernantes from './pages/nosotros/Gobernantes';
import TribunalSuperior from './pages/organismos/TribunalSuperior';
import GranBiblioteca from './pages/organismos/GranBiblioteca';
import InstitutoHistorico from './pages/organismos/instituto/InstitutoHistorico';
import JuradoElectoral from './pages/organismos/JuradoElectoral';
import Fopremas from './pages/organismos/Fopremas';
import Camaras from './pages/instruccion/Camaras';
import ConsejoSimbolismo from './pages/instruccion/ConsejoSimbolismo';
import Adaem from './pages/instruccion/Adaem';
import OtrosAltares from './pages/logias/OtrosAltares';
import LogiasGLP from './pages/logias/LogiasGLP';
import Noticias from './pages/Noticias';
import Decretos from './pages/despacho/Decretos';
import Publicaciones from './pages/Publicaciones';
import Videos from './pages/Videos'
import QuieroSerMason from './pages/QuieroSerMason';
import RegistroPublico from './pages/RegistroPublico'; 

// ==========================================
// 2. IMPORTACIONES INTRANET 
// ==========================================
import { AuthProvider, useAuth } from './pages/intranet/context/AuthContext';
import MainLayout from './pages/intranet/layouts/MainLayout';
import Login from './pages/intranet/pages/Login';
import Inicio from './pages/intranet/pages/Inicio';
import DatosLogia from './pages/intranet/pages/DatosLogia';
import Secretaria from './pages/intranet/pages/Secretaria';
import Tesoreria from './pages/intranet/pages/Tesoreria';
import AsistenciasLogia from './pages/intranet/pages/AsistenciasLogia';
import MegaAdmin from './pages/intranet/pages/MegaAdmin';
import VideosAdmin from './pages/intranet/pages/VideosAdmin';
import NoticiasAdmin from './pages/intranet/pages/NoticiasAdmin';
import PublicacionesAdmin from './pages/intranet/pages/PublicacionesAdmin';
import SolicitudesAdmin from './pages/intranet/pages/SolicitudesAdmin';

// ==========================================
// 3. COMPONENTES DE CONFIGURACIÓN DE RUTAS
// ==========================================

// A. Protector de Rutas Avanzado (Valida Sesión y Rol)
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user } = useAuth();
  
  if (!user) {
    // Si no hay sesión, al login
    return <Navigate to="/intranet/login" replace />;
  }

  // Si la ruta exige un rol específico (ej. ADMIN) y el usuario no lo tiene
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Expulsado al inicio de la intranet por falta de permisos
    return <Navigate to="/intranet/inicio" replace />;
  }

  return children;
};

// B. Envoltura para el Layout Público
const PublicWrapper = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

// ==========================================
// 4. APLICACIÓN PRINCIPAL
// ==========================================
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          
          {/* ------------------------------------------- */}
          {/* ZONA INTRANET (Sin el Layout Público)         */}
          {/* ------------------------------------------- */}
          <Route path="/intranet/login" element={<Login />} />
          
          {/* Capa base de protección: Solo usuarios logueados */}
          <Route path="/intranet" element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/intranet/inicio" replace />} />
            <Route path="inicio" element={<Inicio />} />
            <Route path="datos-logia" element={<DatosLogia />} />
            <Route path="secretaria" element={<Secretaria />} />
            <Route path="tesoreria" element={<Tesoreria />} />
            <Route path="asistencia" element={<AsistenciasLogia />} />

            {/* Capa estricta de protección: Solo Mega Admins */}
            <Route path="admin" element={<ProtectedRoute allowedRoles={['ADMIN']}><MegaAdmin /></ProtectedRoute>} />
            <Route path="admin/videos" element={<ProtectedRoute allowedRoles={['ADMIN']}><VideosAdmin /></ProtectedRoute>} />
            <Route path="admin/noticias" element={<ProtectedRoute allowedRoles={['ADMIN']}><NoticiasAdmin /></ProtectedRoute>} />
            <Route path="admin/publicaciones" element={<ProtectedRoute allowedRoles={['ADMIN']}><PublicacionesAdmin /></ProtectedRoute>} />
            <Route path="admin/solicitudes" element={<ProtectedRoute allowedRoles={['ADMIN']}><SolicitudesAdmin/></ProtectedRoute>} />
          </Route>

          {/* ------------------------------------------- */}
          {/* ZONA PÚBLICA (Con el Layout original)         */}
          {/* ------------------------------------------- */}
          <Route element={<PublicWrapper />}>
            <Route path="/" element={<Home />} />
            
            <Route path="/autoridades/gran-maestro" element={<GranMaestro />} />
            <Route path="/autoridades/gran-cuadro" element={<GranCuadro />} />
            
            <Route path="/nosotros/historia" element={<Historia />} />
            <Route path="/nosotros/antiguos-linderos" element={<AntiguosLinderos />} />
            <Route path="/nosotros/masones-gobernantes" element={<Gobernantes />} />
            
            <Route path="/organismos/tribunal-superior-de-justicia" element={<TribunalSuperior />} />
            <Route path="/organismos/gran-biblioteca" element={<GranBiblioteca />} />
            <Route path="/organismos/instituto-historico" element={<InstitutoHistorico />} />
            <Route path="/organismos/jurado-electoral" element={<JuradoElectoral />} />
            <Route path="/organismos/fopremas" element={<Fopremas />} />
            
            <Route path="/instruccion/camaras-vv-mm-ii" element={<Camaras />} />
            <Route path="/instruccion/consejo-simbolismo" element={<ConsejoSimbolismo />} />
            <Route path="/instruccion/adaem" element={<Adaem />} />
            
            <Route path="/logias/otros-altares" element={<OtrosAltares />} />
            <Route path="/logias/logias-glp" element={<LogiasGLP />} />
            
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/despacho/decretos" element={<Decretos />} />
            <Route path="/publicaciones" element={<Publicaciones />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/quiero-ser-mason" element={<QuieroSerMason />} />
            
            {/* Ruta 404 Pública */}
            <Route path="*" element={
              <div className="text-center py-40 min-h-screen bg-[#050505] flex flex-col justify-center items-center">
                <h2 className="text-4xl font-serif text-[#C5A059] mb-4">404</h2>
                <p className="text-white tracking-widest uppercase">Página no encontrada o en construcción</p>
              </div>
            } />
          </Route>

          {/* ------------------------------------------- */}
          {/* RUTAS HUÉRFANAS (Públicas pero sin Layout)    */}
          {/* ------------------------------------------- */}
          {/* [NUEVO] La vista de registro a través de invitación efímera */}
          <Route path="/registro-publico/ref=:token" element={<RegistroPublico />} />

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;